import React from 'react'
import { Col, Container, Row, Card } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import CustomButton from '../CustomButton'
import { useNavigate } from 'react-router-dom'

const Banner = () => {
  const navigate = useNavigate();
  return (
    <div class="voloto-banner">
      <Container className='h-85'>
        <Row className=''>
          <Col lg={8} className=''>
            <SectionHeader mainText1="CONTACT US"  />
            <h1>One step closer <br></br>to success!</h1>
            <p>We are committed to lead you a best IT <br></br>Solution & Services for your business needs.</p>
          </Col>
          <Col lg={4} className=''>
             <div className='card-shape'>

              <span><img src="images/user1.png" alt="User1" /><img src="images/user2.png" alt="User2" /></span>
              <h3>We are here to help!</h3>
              <p>No matter what stage your idea or project is in. Let's meet to discuss and plan the next steps to make it happen in the most efficient way.</p>
              <h4><img src="images/tick.svg" alt="tick" /><span>We'll get back to you within 8 hours!</span></h4>
              <CustomButton buttonText="Schedule a Call" buttonType="FooterBtn" onClick={() => navigate("/contact")} arrow />
              </div>
          </Col>
        </Row>
      </Container>
      
     <img className='banner-vector' src="images/Union.svg" alt="vector" />
    </div>
  )
}

export default Banner
